var _g, _path, _polygon, _path2, _polygon2, _g2, _path3, _g3, _circle, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRanking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 668.6,
    height: 593.48,
    viewBox: "0 0 668.6 593.48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58.96,
    width: 558.67,
    height: 426.47,
    rx: 21.76,
    ry: 21.76
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.72,5c-9.24,0-16.76,7.52-16.76,16.76v382.94c0,9.24,7.52,16.76,16.76,16.76h515.15c9.24,0,16.76-7.52,16.76-16.76V21.76c0-9.24-7.52-16.76-16.76-16.76H80.72Z",
    fill: "#fcdcc5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.29,
    y: 2.55,
    width: 3.99,
    height: 421.84
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 314.57,
    cy: 65.58,
    r: 5.65
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362.01,
    cy: 65.58,
    r: 5.65
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 314.57,
    cy: 139.41,
    r: 5.65
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362.01,
    cy: 139.41,
    r: 5.65
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 314.57,
    cy: 213.23,
    r: 5.65
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362.01,
    cy: 213.23,
    r: 5.65
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 314.57,
    cy: 287.06,
    r: 5.65
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362.01,
    cy: 287.06,
    r: 5.65
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 314.57,
    cy: 360.88,
    r: 5.65
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362.01,
    cy: 360.88,
    r: 5.65
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.09,62.97l-1.05-1.7c.26-.16,26.1-15.77,48.54.03l-1.15,1.64c-21.36-15.04-46.1-.12-46.34.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.09,69.9l-1.05-1.7c.26-.16,26.1-15.77,48.54.03l-1.15,1.64c-21.36-15.04-46.1-.12-46.34.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.09,137.12l-1.05-1.7c.26-.16,26.1-15.77,48.54.03l-1.15,1.64c-21.36-15.04-46.1-.12-46.34.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.09,144.06l-1.05-1.7c.26-.16,26.1-15.77,48.54.03l-1.15,1.64c-21.36-15.04-46.1-.12-46.34.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.09,211.27l-1.05-1.7c.26-.16,26.1-15.77,48.54.03l-1.15,1.64c-21.36-15.04-46.1-.12-46.34.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.09,218.21l-1.05-1.7c.26-.16,26.09-15.77,48.54.03l-1.15,1.64c-21.36-15.04-46.1-.12-46.34.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.09,285.42l-1.05-1.7c.26-.16,26.1-15.77,48.54.03l-1.15,1.64c-21.36-15.03-46.1-.12-46.34.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.09,292.36l-1.05-1.7c.26-.16,26.09-15.77,48.54.03l-1.15,1.64c-21.36-15.04-46.1-.12-46.34.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.09,359.57l-1.05-1.7c.26-.16,26.1-15.77,48.54.03l-1.15,1.63c-21.36-15.04-46.1-.12-46.34.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.09,366.51l-1.05-1.7c.26-.16,26.1-15.77,48.54.03l-1.15,1.63c-21.36-15.04-46.1-.12-46.34.03Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m420.93 367.41c-1.21 7.36-6.12 12.64-10.96 11.79-4.85-0.85-7.79-7.51-6.58-14.87 0.44-2.95 1.61-5.74 3.4-8.13l5.53-31.12 15.05 3.15-7.05 30.34c0.93 2.87 1.14 5.9 0.61 8.84z",
    fill: "none",
    stroke: "#000"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "472.03 574.33 451.13 574.33 439.01 462.64 471.32 462.64",
    fill: "none",
    stroke: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M430.77,592.29c-2.2,0-4.16-.05-5.63-.19-5.55-.51-10.85-4.61-13.51-7-1.19-1.07-1.58-2.79-.96-4.27h0c.45-1.06,1.34-1.85,2.45-2.17l14.67-4.19,23.76-16.03.27.48c.1.18,2.43,4.38,3.21,7.22.3,1.08.22,1.98-.23,2.68-.31.48-.75.76-1.1.92.43.45,1.78,1.36,5.93,2.02,6.07.96,7.33-5.32,7.39-5.58l.04-.21.18-.12c2.88-1.86,4.66-2.7,5.27-2.52.38.11,1.02.31,2.74,17.41.17.54,1.38,4.47.56,8.24-.89,4.1-18.78,2.69-22.36,2.36-.1.01-13.49.96-22.67.96Z",
    fill: "#f65e2f",
    strokeWidth: 0
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "519.26 574.33 498.35 574.33 486.23 462.64 518.54 462.64",
    fill: "none",
    stroke: "#000"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#f65e2f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M478,592.29c-2.2,0-4.16-.05-5.63-.19-5.55-.51-10.85-4.61-13.51-7-1.19-1.07-1.58-2.79-.96-4.27h0c.45-1.06,1.34-1.85,2.45-2.17l14.67-4.19,23.76-16.03.27.48c.1.18,2.43,4.38,3.21,7.22.3,1.08.22,1.98-.23,2.68-.31.48-.75.76-1.1.92.43.45,1.78,1.36,5.93,2.02,6.07.96,7.33-5.32,7.39-5.58l.04-.21.18-.12c2.89-1.86,4.66-2.7,5.27-2.52.38.11,1.02.31,2.74,17.41.17.54,1.38,4.47.56,8.24-.89,4.1-18.78,2.69-22.36,2.36-.1.01-13.49.96-22.67.96Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "525.27 299.99 423.7 299.99 460.21 179.82 500.71 179.82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.6,179.84s-25.23-.66-27.88,5.98c-2.66,6.64-33.86,164.65-33.86,164.65h20.58l41.16-170.62Z"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 475.6,
    cy: 152.89,
    r: 22.24,
    fill: "none",
    stroke: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m504.16 299.99h-66.66l-36.47 149.69c-0.67 6.32 3.34 12.22 9.48 13.87 20.01 5.36 68.03 12.95 140.7-8.2 6.99-2.03 10.96-9.41 8.77-16.36z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m477.21 179.82 20.73-0.91c8.98 0.68 17.1 5.56 21.91 13.17 14.65 23.16 42.06 71.97 17.59 78.66-32.26 8.81-47.89-40.24-47.89-40.24z",
    fill: "#f65e2f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m462.1 203.46 50.76-36.96c0.6-0.44 1.44-0.3 1.88 0.3l1.23 1.69c0.44 0.6 0.3 1.44-0.3 1.88l-50.75 36.96h-0.01l-6.73 2.9-0.51-0.7z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m474.1 200.37c-4.26-6.12-4.41-13.33-0.35-16.1 4.07-2.77 10.82-0.04 15.08 6.08 1.74 2.42 2.84 5.24 3.22 8.2l17.71 26.18-12.99 8.23-16.08-26.68c-2.67-1.41-4.93-3.44-6.59-5.91z",
    fill: "none",
    stroke: "#000"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0
  }, /*#__PURE__*/React.createElement("polygon", {
    transform: "translate(4,6)",
    points: "497.24 247.4 480.58 215.54 495.21 202.07 524.14 229.01",
    fill: "#f65e2f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.83,75.9c20.55-.79,41.12-1.13,61.69-1.01s40.8.69,61.17,1.72c11.6.58,23.18,1.31,34.76,2.19,1.93.15,1.92-2.86,0-3-20.51-1.55-41.05-2.64-61.61-3.28s-40.8-.8-61.2-.53c-11.61.16-23.22.46-34.82.91-1.92.07-1.93,3.07,0,3h0Z",
    fill: "#f65e2f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.83,109.84c20.55-.79,41.12-1.13,61.69-1.01s40.8.69,61.17,1.72c11.6.58,23.18,1.31,34.76,2.19,1.93.15,1.92-2.86,0-3-20.51-1.55-41.05-2.64-61.61-3.28s-40.8-.8-61.2-.53c-11.61.16-23.22.46-34.82.91-1.92.07-1.93,3.07,0,3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.83,143.78c16.68-.65,33.37-1.39,50.07-1.68,14.28-.25,28.56-.02,42.82.67,10.17.49,20.33,1.18,30.49,1.94,1.93.15,1.92-2.86,0-3-16.64-1.26-33.3-2.29-49.99-2.61-14.28-.27-28.57.04-42.84.52-10.18.35-20.36.76-30.55,1.16-1.92.07-1.93,3.07,0,3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.83,177.72c17.66-.68,35.33-1.4,53-1.66,15.82-.24,31.65-.03,47.46.69,10.53.48,21.05,1.15,31.57,1.95,1.93.15,1.92-2.86,0-3-17.62-1.33-35.26-2.32-52.92-2.62-15.83-.28-31.66,0-47.48.5-10.54.33-21.08.74-31.62,1.15-1.92.07-1.93,3.07,0,3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.83,211.65c16.06-.62,32.1-1.6,48.15-2.35,13.26-.62,26.52-.83,39.79-.39,9.94.33,19.87.95,29.78,1.7,1.93.15,1.92-2.86,0-3-16-1.21-32.02-2.06-48.07-1.94-13.29.1-26.55.87-39.81,1.58-9.94.53-19.89,1.01-29.84,1.4-1.92.07-1.93,3.08,0,3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.83,245.59c20.55-.79,41.12-1.13,61.69-1.01s40.8.69,61.17,1.72c11.6.58,23.18,1.31,34.76,2.19,1.93.15,1.92-2.86,0-3-20.51-1.55-41.05-2.64-61.61-3.28s-40.8-.8-61.2-.53c-11.61.16-23.22.46-34.82.91-1.92.07-1.93,3.07,0,3h0Z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    transform: "scale(-1,1)",
    cx: -473.56,
    cy: 151.29,
    r: 22.481,
    fill: "none",
    stroke: "#000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m479.73 149.06c-3.7676-0.11191-6.2337-3.9209-7.6968-7.3901-1.4631-3.4733-2.9676-7.4605-6.4534-8.8946-2.8557-1.173-7.8916 6.7476-10.146 4.638-2.3459-2.1967-0.058-13.495 2.433-15.526 2.491-2.0268 5.9021-2.4247 9.1143-2.5697 7.8336-0.3606 15.717 0.27355 23.393 1.8776 4.7499 0.99059 9.6407 2.4827 13.064 5.9187 4.3354 4.3561 5.4503 10.93 5.7612 17.068 0.31913 6.2834-0.0414 12.865-3.0961 18.365-3.0547 5.5001-9.4542 9.5536-15.584 8.1527-0.61756-3.3324 0.0125-6.7518 0.24868-10.138 0.23626-3.3821-0.0124-7.0378-2.0765-9.7277s-6.4782-3.7593-8.8822-1.3719",
    strokeWidth: 0.41447
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m496.1 125.05c0.3134-2.7728 1.1258-5.683 3.2498-7.4904 2.2971-1.9523 5.8181-2.1384 8.4826-0.72952 2.6644 1.4089 4.4409 4.2206 4.9336 7.1954 0.49538 2.9718-0.20681 6.0682-1.6068 8.7353-0.80889 1.5432-1.9221 3.0312-3.5126 3.7407-2.351 1.0511-5.4347-0.0623-6.5722-2.3746",
    strokeWidth: 0.41447
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRanking);
export default __webpack_public_path__ + "static/media/ranking.54b6c9443be53bb33a8aa1db7a441284.svg";
export { ForwardRef as ReactComponent };